import {CSSProperties} from 'styled-components';

import {BodyText, TextThemes, BodyTypes} from 'components/design-guide';
import FormattedMessage from 'shared/IntlFormatMessage/components/FormattedMessage';
import {GLOBAL_TRANSLATIONS} from 'shared/IntlFormatMessage/translations/globalTranslations';

interface Props {
  optionalCSS: CSSProperties;
  isLifeCompany?: boolean;
}

const Copyright = ({optionalCSS, isLifeCompany}: Props) => (
  <BodyText {...{optionalCSS}} textTheme={TextThemes.INFO} type={BodyTypes.SMALLBODYSPAN}>
    &copy;
    <span style={{marginLeft: '2px'}}>
      {new Date().getFullYear()}{' '}
      <FormattedMessage
        message={GLOBAL_TRANSLATIONS.AMICA}
        values={{includeFullName: true, showLife: !!isLifeCompany}}
      />
    </span>
  </BodyText>
);

export default Copyright;
